import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';
import {Info} from '../model/info';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css'],
    standalone: false
})
export class InfoComponent implements OnInit, OnDestroy {

  data: Info;
  dataSubscription: Subscription;

  constructor(private appService: AppService) { }

  ngOnInit() {

    this.dataSubscription = this.appService.infoData
      .subscribe((data: Info) => {
        this.data = data;
      });

    this.appService.fetchInfo();
  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
  }

}
